// src/utils/download.js
import axios from 'axios';
import Vue from 'vue';

export async function apiDownload(apiUrl, params, fileName) {
  console.log('process.env.NODE_ENV',process.env.NODE_ENV)
  if(process.env.NODE_ENV !== 'development'){
    if (apiUrl.startsWith('/ai_videos/')) {
      apiUrl = apiUrl.replace('/ai_videos/', 'https://oss.ylw.s136.ailo.vip/');
    }
    if (apiUrl.startsWith('/ai2_videos/')) {
      apiUrl = apiUrl.replace('/ai2_videos/', 'https://aigc.oss.ylwai.cn/');
    }
  }
  if(process.env.NODE_ENV !== 'development'){
    if (apiUrl.startsWith('/ai_images/')) {
      apiUrl = apiUrl.replace('/ai_images/', 'https://oss.ylw.s136.ailo.vip/');
    }
    if (apiUrl.startsWith('/ai2_images/')) {
      apiUrl = apiUrl.replace('/ai2_images/', 'https://aigc.oss.ylwai.cn/');
    }
  }
  let _filetype = '.jpg'
  if(apiUrl.indexOf('.mp4') >= 0){
    _filetype = '.mp4'
  }
  console.log('apiUrl',apiUrl,_filetype)
  try {
    let _authorization = `Bearer ${localStorage.getItem('token')}`
    console.log('authorization',_authorization)

    let _filename  = fileName || 'file' + new Date().getTime()
    console.log('download_filename',_filename)
    
    if (/android/i.test(navigator.userAgent)) {
      // console.log('uniapp下载')
      // window.postMessage({
      //   type: 'DOWNLOAD_FILE',
      //   url: apiUrl,
      //   filename: _filename
      // });
      // window.postMessage({
      //   type: 'DOWNLOAD_FILE',
      //   data: {apiUrl, _filename}
      // });
      // console.log('typeof AndroidBridge', typeof AndroidBridge)
      // if (typeof AndroidBridge !== 'undefined') {
      //   console.log('原生Android')
      //   // 调用原生Android方法
      //   AndroidBridge.downloadFile(downloadUrl, fileName || _filename);
      // // } else if (typeof uni !== 'undefined') {
      // }
      // console.log('typeof uni', typeof uni)
      // if (typeof uni !== 'undefined') {
      //   console.log('UniApp环境')
      //   // UniApp环境处理
      //   uni.postMessage({
      //     type: 'DOWNLOAD_FILE',
      //     data: {downloadUrl, _filename}
      //   });
      // }
      _filename = _filename + _filetype
      const downloaderTask = window.plus.downloader.createDownload(
        apiUrl,
        {
          // filename: `_downloads/${_filename}`, // 保存路径
          filename: `_downloads/${_filename}`, // 保存路径
          retry: 2, // 重试次数
          timeout: 120 // 超时时间(秒)
        },
        (d, status) => {
          // 下载完成回调
          console.log('android downloader',d,status)
          // window.plus.runtime.openFile(d.filename)
          // 解析临时文件
          // window.plus.io.resolveLocalFileSystemURL(d.filename, (tempEntry) => {
            
          //   // 获取永久存储目录
          //   console.log('tempEntry', tempEntry)
          //   // const permanentDir = 'file:///storage/emulated/0/Download/'
          //   const permanentDir = window.plus.io.PUBLIC_DOWNLOADS
          //   console.log('permanentDir', permanentDir)
          //   window.plus.io.resolveLocalFileSystemURL(permanentDir, (dirEntry) => {
          //     console.log('dirEntry', dirEntry)
          //     // 移动文件
          //     tempEntry.moveTo(dirEntry,
          //     (newEntry) => {
          //       console.log('文件保存成功:', newEntry.fullPath);
          //     },
          //     (error) => {
          //       console.error('移动失败', error.code, error.message);
          //     });
          //   });
          //     // 移动文件
          //   // tempEntry.moveTo(permanentDir, (newEntry) => {
          //   //   console.log('文件保存成功:', newEntry.fullPath);
          //   // });
          // });
          window.plus.gallery.save(d.filename, () => {
            console.log('title', '文件已保存到相册');
            Vue.prototype.$message({
              message: '文件已保存到相册',
              type: 'success',
              offset: 300,
              duration: 1000,
            });
          }, (error) => {
            console.error('保存到相册失败', error);
          });
        }
      );

      downloaderTask.start();

      // const downloadTask = window.plus.runtime.downloadFile(apiUrl, {
      //   filename: `_downloads/${_filename}`, // 文件保存路径
      //   retry: 2, // 重试次数
      //   timeout: 120, // 超时时间(秒)
      // }, (download, status) => {
      //   console.log('downloadFile',download,status)
      //   // 下载完成回调
      // });
      return
    }
    
    const response = await axios({
      method: 'get', // 或 'get'，根据 API 要求
      url: apiUrl,
      data: params, // 请求参数
      responseType: 'blob', // 关键：指定响应类型为 blob
      headers: {
        'Authorization': _authorization // 认证头
      }
    });
    
    // 创建 Blob 对象
    const blob = new Blob([response.data], {
      type: response.headers['content-type']
    });
    
    // 创建下载链接
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', _filename);
    
    // 触发下载
    document.body.appendChild(link);
    link.click();

    // 获取文件名
    // const filename = getFilenameFromUrl(link);
    
    // 清理
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(link);
  } catch (error) {
    console.error('文件下载失败:', error);
    // 处理错误，例如显示通知
  }
}


// WEBPACK FOOTER //
// ./src/utils/download.js